<script lang="ts">
  import { get, writable } from "svelte/store";
  import Input from "../../components/Form/Fields/Input.svelte";
  import FormField from "../../components/Form/FormField.svelte";
  import FormLayout from "../../layout/FormLayout.svelte";
  import type { ICustomerQuickCreateDTO } from "../../services/DTO/customer-quick-create-dto";
  import { createEventDispatcher, onMount } from "svelte";
  import type { IApiResponse } from "../../utils/api/api-response";
  import { CustomerService } from "../../services/customer.service";
  import type { ICustomerQuickCreateResponseDTO } from "../../services/DTO/customer-quick-create-response-dto";

  const record = writable<ICustomerQuickCreateDTO | null>(null);
  const dispatch = createEventDispatcher();

  $: canSubmit = $record != null && $record.name != "";

  function initCustomer() {
    record.set({
      name: "",
      street: "",
      civicNumber: "",
      city: "",
      province: "",
      country: "",
      zipCode: "",
      vatNumber: "",
      fiscalCode: "",
      phone1: "",
      cod317: "",
    });
  }

  async function onSubmit() {
    let dto = get(record);

    if (dto == null) {
      onCancel();
      return;
    }

    let _resp: IApiResponse<ICustomerQuickCreateResponseDTO> = await CustomerService.quickCreateCustomer(dto);
    let data = _resp.payload;

    dispatch("create", data);
  }

  function onCancel() {
    dispatch("cancel");
  }

  onMount(() => initCustomer());
</script>

{#if $record}
  <h1 class="title">Inserimento rapido cliente</h1>

  <div class="columns">
    <div class="column is-12">
      <FormLayout {canSubmit} isNew={true} on:submit={onSubmit} on:cancel={onCancel}>
        <div class="columns">
          <div class="column is-6">
            <FormField>
              <Input name="Denominazione" placeholder="denominazione" required={true} bind:value={$record.name} />
            </FormField>
          </div>
        </div>

        <div class="columns">
          <div class="column is-6">
            <FormField>
              <Input name="Indirizzo principale" placeholder="indirizzo" required={false} bind:value={$record.street} />
            </FormField>
          </div>
          <div class="column is-1">
            <FormField>
              <Input name="Civico" placeholder="civico" required={false} bind:value={$record.civicNumber} />
            </FormField>
          </div>
          <div class="column is-3">
            <FormField>
              <Input name="Comune" placeholder="comune" required={false} bind:value={$record.city} />
            </FormField>
          </div>
          <div class="column is-1">
            <FormField>
              <Input name="Provincia" placeholder="provincia" maxlength={2} required={false} bind:value={$record.province} />
            </FormField>
          </div>
          <div class="column is-1">
            <FormField>
              <Input name="CAP" placeholder="CAP" required={false} bind:value={$record.zipCode} />
            </FormField>
          </div>
        </div>

        <div class="columns">
          <div class="column is-6">
            <FormField>
              <Input name="Codice Fiscale" placeholder="codice fiscale" required={false} bind:value={$record.fiscalCode} />
            </FormField>
          </div>
          <div class="column is-6">
            <FormField>
              <Input name="Partita IVA" placeholder="partita iva" required={false} bind:value={$record.vatNumber} />
            </FormField>
          </div>
        </div>

        <div class="columns">
          <div class="column is-3">
            <FormField>
              <Input name="Telefono 1" placeholder="" required={false} bind:value={$record.phone1} />
            </FormField>
          </div>
          <div class="column is-3">
            <FormField>
              <Input name="Codice 317" placeholder="codice 317" required={false} bind:value={$record.cod317} />
            </FormField>
          </div>
        </div>
      </FormLayout>
    </div>
  </div>
{/if}
